import { CalendarRangeOutlineIcon } from './CalendarRangeOutlineIcon';

/**
 * author: Google
 * id CD7FA7FC-1BB0-4DB6-82C6-DF13E5A55EB2
 * name calendar-range-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-range-outline.svg
 * tags
 * - Date / Time 
 */
export const EventRangeOutlineIcon = CalendarRangeOutlineIcon;
export default EventRangeOutlineIcon